<template>
  <div>
    <div>
      <div class="header">
        <div class="header-img">
          <div class="headbar" id="nav">
            <div class="container" id="header">
              <div id="logo">
                <img src="https://cdn2.iconfinder.com/data/icons/flat-sports/1020/Flat_Icon_Designs-04-512.png" alt="">
                <a href="#">Spoctivity</a>
              </div>
              <div id="navigation">
                <div class="nav-left" id="navleft">
                  <a class="active"> Startseite</a>
                  <a href="about.html"> Über uns</a>
                  <a href="#contact"> Kontakt</a>
                </div>
                <div class="nav-right">
                  <a class="login" href="#/login"> Login </a>
                </div>
              </div>
              <div id="canvas" class="sidecanvas" v-on:click="showMobileNav = false"></div>
              <div id="mySidenav" class="sidenav">
              </div>
              <div id="mobilemenu" v-on:click="showMobileNav = true">
                <b-icon icon="list"></b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="mnav" class="mobile_sidenav">
      <span href="#" class="mobile_sidenav_close" v-on:click="showMobileNav = false">&times;</span>
      <a href="#" v-on:click="showMobileNav = false">Startseite</a>
      <a href="#contact" v-on:click="showMobileNav = false">Über uns</a>
      <a href="#contact" v-on:click="showMobileNav = false">Kontakt</a>
      <div class="line">
        <hr>
      </div>
      <a href="/#/login">Login</a>
    </div>

    <section class="content">

      <div class="container">
        <div class="steps">
          <h3 class="steps-hl">Das ist Spoctitty</h3>
          <h4 class="steps-mhl">Einfach und bequem Sport spielen</h4>
          <div class="flex-container">
            <div class="stepbox">
              <div class="stepimage">
                <img src="../assets/Bilder/1.png">
                <span class="stepnumber"> 1 </span>
              </div>
              <span class="stepboxhl"> Leute finden </span>
              <p> Du suchst Leute in der Umgebung, die deine Sportart spielen </p>
            </div>
            <span class="arrow"></span>
            <div class="stepbox">
              <div class="stepimage">
                <img src="../assets/Bilder/2.png">
                <span class="stepnumber"> 2 </span>
              </div>
              <span class="stepboxhl"> Ereignis erstellen </span>
              <p> Auf Spoctitty ein Event erstellen und Leute dazu einladen. Ggf Mietung einer Sporthalle </p>
            </div>
            <span class="arrow"></span>
            <div class="stepbox">
              <div class="stepimage">
                <img src="../assets/Bilder/3.png">
                <span class="stepnumber"> 3 </span>
              </div>
              <span class="stepboxhl"> Spiel spielen </span>
              <p> Spielt gemeinsam euer Ding </p>
            </div>

          </div>
        </div>

      </div>
      <div class="container">
        <div class="flex-container" id="cards">
          <div class="col">
            <img src="../assets/Bilder/1.jpg" alt="">
            <h3> Organisieren</h3>
            <p> et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
              est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
            </p>

          </div>
          <div class="col">
            <img src="../assets/Bilder/2.jpg" alt="">
            <h3> Zufriedenheit</h3>
            <p> et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
              est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
            </p>

          </div>
          <div class="col">
            <img src="../assets/Bilder/3.jpg" alt="">
            <h3> Geilomat <span style="float:right"> 500€</span></h3>
            <p> et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
              est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
            </p>

          </div>
        </div>
      </div>
      <div class="containmax bg-color" >
        <div class="container flex-container" target="nm">
          <div class="col70">
            <div class="appcaption">
              <h3> Spocitivity App herunterladen </h3>
              <span> und jederzeit am richtigen Ort treffen</span>
            </div>
            <div class="applogos">
              <a href=""><img src="../assets/Bilder/ggplay.png"> </a>
              <a href=""> <img src="../assets/Bilder/aios.png"></a>
            </div>
          </div>
          <div class="col30">
            <div class="appimg">
              <img src="../assets/Bilder/Huawei-P20-Pro1.png">
            </div>
          </div>
        </div>
      </div>

      <div class="container ">
        <div class="flex-container main-end">
          <div id="pic-end" class="col30">
            <img src="../assets/Bilder/para.jpg">
          </div>
          <div class="col70">
            <h1>SportTreff</h1>
            <p>Warum Spoctivity?</p>
            <p style="text-align: justify"> kostenlos und einfach. Ut enim ad minim veniam, quis nostrud exercitation
              ullamco laboris nisi ut
              aliquip ex ea commodo consequat.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut
            </p>
          </div>
        </div>
      </div>
    </section>

    <div class="footer" id="contact">
      <div class="flex-container container footer-content">
        <div class="col2">
          <h2> Über uns</h2>
          <p> aliquip ex ea commodo consequat.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut </p>
        </div>
        <div class="col2">
          <h2> Kontakt</h2>
          <p> Musterstraße 1337, 38679 Leipzig</p>
          <p> Tel.: 0123 4567890 <br>
            E-Mail: kontakt@spoctivity.de</p>
        </div>
      </div>
    </div>
    <div class="impressum">
      <a href="">Datenschutz und Nutzungsbedinungen</a> <span>|</span> <a href="">Impressum</a>
    </div>
    
    <a href="#" class="to-top" id="topbtn"></a>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      showMobileNav: false
    }
  },
  watch: {
    showMobileNav(val) {
      let nav = document.getElementById('mnav')
      if (val === true) {
        nav.style.width = '100%'
      } else {
        nav.style.width = '0'
      }
    }
  }
}
window.onscroll = function () {
  scrollFunction()
};

function scrollFunction() {
  /**
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("header").style.padding = "10px 30px";
    if(document.getElementById("topbtn")) {
      document.getElementById("topbtn").style.display = "block";
    }
  } else {
    if(document.getElementById("topbtn")) {
      document.getElementById("topbtn").style.display = "none";
    }
    document.getElementById("header").style.padding = "30px";
  }**/
}
</script>

<style scoped>
a:hover {
  text-decoration: none;
}
:target {
  margin: 0;
}
/*----------- Header Text -----------*/

.header .header-text {
  display: table;
  text-align: center;
  width: 100%;
  min-height: 500px;
  margin-left: auto;
  margin-right: auto;
  vertical-align: bottom;
}

.inner-text {
  display: table-cell;
  vertical-align: bottom;
  color: white;
}

.inner-text p {
  font-size: 20px;
  text-transform: capitalize;
  font-weight: 300;
  color: #fff;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}

.inner-text h1 {
  font-size: 50px;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1;
  color: #fff;
}

#reg-button {
  display: inline-block;
  padding: 14px 45px;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  background-color: #ff0000;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  text-transform: capitalize;
  border: 3px solid transparent;
  margin-bottom: 30px;
  cursor: pointer;
}

#reg-button:hover {
  border: 3px solid white;
  background-color: yellow;
  color: black !important;
  transform: scale(1.2);
}
/*----------- Para Background -----------*/

.para {
  background-image: url("../assets/Bilder/para.jpg");
  height: 500px;
  position: relative;
  opacity: 1;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.para .caption {
  position: absolute;
  left: 0;
  top: 40%;
  width: 100%;
  text-align: center;
}

.caption span.border {
  background-color: white;
  color: black;
  font-size: 50px;
  font-weight: bolder;
  padding: 18px;
  letter-spacing: 10px;
  mix-blend-mode: screen;
}
.col30 img {
  display: block;
  max-width: 100%;
}

/*----------- 123 Content -----------*/

.flex-container {
  flex-wrap: nowrap;
}

.steps {
  position: relative;
  margin: 0 auto;
  height: 100%;
  padding: 0;
  overflow: hidden;
}

.steps .steps-hl {
  margin: 8px 0 16px;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.4rem;
}

.steps .steps-mhl {
  font-weight: 600;
  margin: 8px 0 16px;
  color: var(--secondary);
  text-align: center;
  font-size: 1.6rem;
  line-height: 2rem;
}

.steps .stepbox{
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  float: left;
  padding: 10px;
  overflow: hidden;
}

.steps .stepbox > p {
  text-align: center;
}

.arrow::before {
  position: absolute;
  top: 50%;
  content: '>';
  font-weight: 400;
  line-height: 1;
  color: #999;
  font-size: 25px;
  display: inline-block;
}

.steps .stepimage {
  display: block;
  text-align: center;
  width: 150px;
  height: 150px;
  position: relative;
}

.steps .stepimage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.steps .stepnumber {
  position: absolute;
  width: 35px;
  height: 35px;
  line-height: 35px;
  color: whitesmoke;
  border-radius: 50%;
  text-align: center;
  background-color: var(--secondary);
  font-size: 15px;
  left:-10px;
  bottom: -10px;
}
.steps .stepboxhl {
  font-weight: 600;
  position: relative;
  display: block;
  margin: 16px 0;
  color: #0a3847;
  font-size: 18px;
  text-align: center;
}
/*----------- App -----------*/
.containmax .col30 {
  height: 400px;
}
.appcaption{
  font-size: 25px ;
  font-weight: bold;
  color: white;
  margin-bottom: 50px;
}

.applogos a{
  display: inline-block;
}
.applogos img {
  max-width:150px ;
}

.appimg{
  height: 100%;
  overflow: hidden;
}

.appimg img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.containmax .container{
  padding-bottom: 0;
}
/*----------- Text und Bild at the end  -----------*/
.main-end{
}
#pic-end{
  order: 2;
}
#pic-end > img{
  height: 100%;
  width: 100%;
  object-fit: cover;
}

/*----------- Mobileseite -----------*/

@media screen and (max-width: 768px) {
  .para {
    height: 300px;
  }
  .steps .flex-container, #cards {
    flex-wrap: wrap;
  }
  .stepbox{
    flex-basis: 100%;
    flex-grow: 1;
  }
  .arrow {
    display: none;
  }
  .appcaption {
    font-size: 1.2rem;
  }
  .main-end{
    flex-direction: column;
  }
  #pic-end{
    height: 300px;
  }
}

@media screen and (max-width: 400px) {
  .appcaption {
    font-size: 1rem;
  }
  h1 {
    font-size: 2rem;
  }
  h2{
    font-size: 1.7rem;
  }

}
</style>